import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CoreService, HttpService } from '../../../services';

@Component({
  selector: 'queoval-pipe-obligation-card',
  templateUrl: './pipe-obligation-card.component.html',
  styleUrls: ['../../pipe-formation/stage-pipe-card/stage-pipe-card.component.css', './pipe-obligation-card.component.css']
})

export class PipeObligationCardComponent implements OnChanges {

  constructor(
    protected indParam: CoreService,
    protected http: HttpService,) { }
  public isMockUp: boolean = true;

  @Input() card: any;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['card']?.currentValue) {
      this.isMockUp = false;
    }
  }
}
